import { t } from "i18next";

import { IndustrialProcessType } from "shared";

export const getIndustrialProcessWording = (process: IndustrialProcessType) =>
  t(`industrialProcesses.${process}`);
